module.exports = __webpack_public_path__ + "static/media/ic_plus.5eea49e4.svg";